export const SFX = {
  tap: '/audio/sfx/tap.wav',
  whoosh: '/audio/sfx/whoosh.wav',
  giggle: '/audio/sfx/giggle.wav',
  sparkle: '/audio/sfx/sparkle.wav',
  snap: '/audio/sfx/snap.wav',
  drumBig: '/audio/sfx/drum-big.wav',
  drumSmall: '/audio/sfx/drum-small.wav',
  bell: '/audio/sfx/bell.wav',
  cymbal: '/audio/sfx/thanh-la.wav',
  woodblock: '/audio/sfx/woodblock.wav',
  lullaby: '/audio/sfx/lullaby.wav',
} as const

/** Pixie §9 copy-table keys for Màu & Hình combo lines. */
export const COMBO_VOICE = {
  'shape.tron.do': '/audio/voice/shape_tron_do_tts_placeholder.wav',
  'shape.tron.vang': '/audio/voice/shape_tron_vang_tts_placeholder.wav',
  'shape.tron.xanhduong': '/audio/voice/shape_tron_xanhduong_tts_placeholder.wav',
  'shape.tron.xanhla': '/audio/voice/shape_tron_xanhla_tts_placeholder.wav',
  'shape.vuong.do': '/audio/voice/shape_vuong_do_tts_placeholder.wav',
  'shape.vuong.vang': '/audio/voice/shape_vuong_vang_tts_placeholder.wav',
  'shape.vuong.xanhduong': '/audio/voice/shape_vuong_xanhduong_tts_placeholder.wav',
  'shape.vuong.xanhla': '/audio/voice/shape_vuong_xanhla_tts_placeholder.wav',
  'shape.tamgiac.do': '/audio/voice/shape_tamgiac_do_tts_placeholder.wav',
  'shape.tamgiac.vang': '/audio/voice/shape_tamgiac_vang_tts_placeholder.wav',
  'shape.tamgiac.xanhduong': '/audio/voice/shape_tamgiac_xanhduong_tts_placeholder.wav',
  'shape.tamgiac.xanhla': '/audio/voice/shape_tamgiac_xanhla_tts_placeholder.wav',
  'color.do.tron': '/audio/voice/color_do_tron_tts_placeholder.wav',
  'color.do.vuong': '/audio/voice/color_do_vuong_tts_placeholder.wav',
  'color.do.tamgiac': '/audio/voice/color_do_tamgiac_tts_placeholder.wav',
  'color.vang.tron': '/audio/voice/color_vang_tron_tts_placeholder.wav',
  'color.vang.vuong': '/audio/voice/color_vang_vuong_tts_placeholder.wav',
  'color.vang.tamgiac': '/audio/voice/color_vang_tamgiac_tts_placeholder.wav',
  'color.xanhduong.tron': '/audio/voice/color_xanhduong_tron_tts_placeholder.wav',
  'color.xanhduong.vuong': '/audio/voice/color_xanhduong_vuong_tts_placeholder.wav',
  'color.xanhduong.tamgiac': '/audio/voice/color_xanhduong_tamgiac_tts_placeholder.wav',
} as const

export type ComboVoiceId = keyof typeof COMBO_VOICE

export const VOICE = {
  batDauChoi: '/audio/voice/bat_dau_choi_tts_placeholder.wav',
  beNghiThoi: '/audio/voice/be_nghi_thoi_nhe_tts_placeholder.wav',
  giuBaGiay: '/audio/voice/giu_ba_giay_tts_placeholder.wav',
  uOa: '/audio/voice/u_oa_tts_placeholder.wav',
  gioiQua: '/audio/voice/gioi_qua_tts_placeholder.wav',
  hayLam: '/audio/voice/hay_lam_tts_placeholder.wav',
  thuLaiNao: '/audio/voice/thu_lai_nao_tts_placeholder.wav',
  dauRoiNhi: '/audio/voice/dau_roi_nhi_tts_placeholder.wav',
  conGa: '/audio/voice/con_ga_tts_placeholder.wav',
  conVit: '/audio/voice/con_vit_tts_placeholder.wav',
  conTrau: '/audio/voice/con_trau_tts_placeholder.wav',
  conMeo: '/audio/voice/con_meo_tts_placeholder.wav',
  conCho: '/audio/voice/con_cho_tts_placeholder.wav',
  conLon: '/audio/voice/con_lon_tts_placeholder.wav',
  xeMay: '/audio/voice/xe_may_tts_placeholder.wav',
  oTo: '/audio/voice/o_to_tts_placeholder.wav',
  mauDo: '/audio/voice/mau_do_tts_placeholder.wav',
  mauVang: '/audio/voice/mau_vang_tts_placeholder.wav',
  mauXanhDaTroi: '/audio/voice/mau_xanh_da_troi_tts_placeholder.wav',
  mauXanhLaCay: '/audio/voice/mau_xanh_la_cay_tts_placeholder.wav',
  hinhTron: '/audio/voice/hinh_tron_tts_placeholder.wav',
  hinhVuong: '/audio/voice/hinh_vuong_tts_placeholder.wav',
  hinhTamGiac: '/audio/voice/hinh_tam_giac_tts_placeholder.wav',
  choiTiepNhe: '/audio/voice/choi_tiep_nhe_tts_placeholder.wav',
  ...COMBO_VOICE,
} as const

export const ALL_SOUND_URLS: readonly string[] = [
  ...new Set([...Object.values(SFX), ...Object.values(VOICE)]),
]

export const LULLABY_MAX_MS = 45_000
